import type { FormFieldConfig } from '../components/common/FormField';

export const tenantFieldConfig: {
  section: string;
  columns: number;
  column: number;
  fields: FormFieldConfig[];
}[] = [
  {
    section: 'Tenant Details',
    columns: 1,
    column: 0,
    fields: [
      { field: 'tenant_name', label: 'Tenant Name', type: 'text' },
      { field: 'unit_name', label: 'Unit Name', type: 'text' },
      { field: 'asset', label: 'Asset', type: 'select', optionsKey: 'assets', optionLabelKey: 'asset_name' },
      { field: 'tenant_sector', label: 'Tenant Sector', type: 'text' },
      { field: 'rent_currency', label: 'Currency', type: 'select', optionsKey: 'currencies', isStringArray: true },
      { field: 'area_type', label: 'Area Type', type: 'select', optionsKey: 'areaTypes', isStringArray: true },
      { field: 'unit_type', label: 'Unit Type', type: 'text' },
    ],
  },
  {
    section: 'Lease Information',
    columns: 1,
    column: 1,
    fields: [
      { field: 'lease_start_date', label: 'Lease Start', type: 'date' },
      { field: 'lease_end_date', label: 'Lease End', type: 'date' },
      { field: 'break_option_date', label: 'Break Date', type: 'date' },
      { field: 'next_review_date', label: 'Review Date', type: 'date' },
      { field: 'total_area', label: 'Area', type: 'number', formatNumber: true },
      { field: 'contracted_rent', label: 'Contracted Rent', type: 'number', formatNumber: true },
      { field: 'passing_rent', label: 'Passing Rent', type: 'number', formatNumber: true },
      { field: 'rent_free_amount', label: 'Rent Free Amount', type: 'number', formatNumber: true },
      { field: 'rent_free_end_date', label: 'Rent Free End Date', type: 'date' },
      { field: 'estimated_rental_value', label: 'ERV', type: 'number', formatNumber: true },
      { field: 'tf_erv', label: 'TF ERV', type: 'number', formatNumber: true },
      { field: 'count_parking', label: 'No. of Parking Spaces', type: 'number' },
      { field: 'parking_erv', label: 'Parking ERV', type: 'number', formatNumber: true },
      { field: 'parking_income', label: 'Parking Income', type: 'number', formatNumber: true },
      { field: 'ios_area', label: 'IOS Area', type: 'number', formatNumber: true },
      { field: 'ios_erv', label: 'IOS ERV', type: 'number', formatNumber: true },
      { field: 'ios_income', label: 'IOS Income', type: 'number', formatNumber: true },
    ],
  },
];
